import { render } from "./ManualsPage.vue?vue&type=template&id=406fc97f&scoped=true"
import script from "./ManualsPage.vue?vue&type=script&lang=js"
export * from "./ManualsPage.vue?vue&type=script&lang=js"

import "./ManualsPage.vue?vue&type=style&index=0&id=406fc97f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-406fc97f"]])

export default __exports__